module.exports = __webpack_public_path__ + "img/C1.0af4b787.png";